export default __webpack_public_path__ + "static/media/047-smartphone.26162237.svg";